import { forwardRef, HTMLChakraProps, useStyleConfig } from '@chakra-ui/react';
import Box, { BoxProps } from '../Box/Box';

export interface CardProps extends BoxProps {
  href?: string;
  variant?: 'elevated' | 'outline';
  withHover?: boolean;
}

/**
 * Basic container element with default box shadow and border radius.
 */
const Card = forwardRef<CardProps, 'div'>((props, ref) => {
  const { as = 'div', variant = 'elevated', withHover, ...rest } = props;
  const css = useStyleConfig('Card', { as, variant, withHover });

  const properties = {
    as,
    ...rest,
  } as BoxProps;
  if (props.as === 'button' && !(props as HTMLChakraProps<'button'>).type) {
    (properties as HTMLChakraProps<'button'>).type = 'button';
  }
  return <Box __css={css} {...properties} ref={ref} />;
});

export default Card;
